// src/data/projects.js

export const projects = [
  {
    title: "IdeaLens",
    desc: "IdeaLens: Detecting AI Ideas in Long-form Writing",
    link: "https://github.com/RishanthRajendhran/IdeaLens",
  },
  {
    title: "POLARIS",
    desc: "POLARIS: Guiding Small Models to Write Long Stories",
    link: "https://github.com/RishanthRajendhran/POLARIS",
  },
  {
    title: "VeriFastScore",
    desc: "VeriFastScore: Speeding up long-form factuality evaluation",
    link: "https://github.com/RishanthRajendhran/VeriFastScore",
  },
  {
    title: "ReasonableLM",
    desc: "Reasonable Language Modeling",
    link: "https://github.com/RishanthRajendhran/reasonableLM",
  },
  {
    title: "C-STaR",
    desc: "Self Taught Reasoner with Certainty",
    link: "https://github.com/vule20/C-STaR",
  },
  {
    title: "ValueAlignmentVerification",
    desc: "Value Alignment Verification for LLMs",
    link: "https://github.com/RishanthRajendhran/ValueAlignmentVerification",
  },
  {
    title: "salASR",
    desc: "Salience for Automatic Speech Recognition",
    link: "https://github.com/jacobkj314/salASR",
  },
  {
    title: "Relation Extraction",
    desc: "Relation extraction using distant supervision",
    link: "https://github.com/RishanthRajendhran/relationExtraction",
  },
  {
    title: "visualQA",
    desc: "Visual Question Answering",
    link: "https://github.com/RishanthRajendhran/visualQA",
  },
  {
    title: "ZARAC",
    desc: "Zero-shot Augmented Rationale Answer pairs with Certainty",
    link: "https://github.com/RishanthRajendhran/ZARAC",
  },
  {
    title: "Robustness Evaluation",
    desc: "Evaluation of consistency (standard decoding and self-consistency) of large-scale finetuned models",
    link: "https://github.com/RishanthRajendhran/robustnessEvaluation",
  },
  {
    title: "EigenGame",
    desc: "Implementation of the EigenGame (PCA as a Nash Equilibrium)",
    link: "https://github.com/RishanthRajendhran/EigenGame",
  },
  {
    title: "CS6350",
    desc: "Lightweight Machine Learning Library developed for CS6350 at UofU",
    link: "https://github.com/RishanthRajendhran/CS6350",
  },
  {
    title: "InfoRetrievalSystem",
    desc: "Lightweight information retrieval system developed for CS6370 at IITM",
    link: "https://github.com/RishanthRajendhran/InformationRetrievalSystem",
  },
  {
    title: "TransliterationUsingRNNs",
    desc: "Transliteration from Tamil to English using RNNs",
    link: "https://github.com/RishanthRajendhran/transliterationUsingRNNs",
  },
  {
    title: "ImageClassificationUsingCNNs",
    desc: "Image classification using CNNs",
    link: "https://github.com/RishanthRajendhran/imageClassificationUsingCNNs",
  },
  {
    title: "CPP",
    desc: "Solutions to several DSA questions in C++",
    link: "https://github.com/RishanthRajendhran/cpp",
  }
];